import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export const ParticlesBackground = () => {
  const [ready, setReady] = useState(false);
  const reduce =
    typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isMobile = typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;

  useEffect(() => {
    let alive = true;
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      if (alive) setReady(true);
    });
    return () => {
      alive = false;
    };
  }, []);

  const options = useMemo(
    () => ({
      fullScreen: false,
      background: { color: { value: "transparent" } },
      fpsLimit: reduce ? 30 : 60,
      detectRetina: true,
      particles: {
        number: { value: isMobile ? 40 : 75, density: { enable: true, width: 1400, height: 900 } },
        color: { value: ["#ffffff", "#c0c0c0"] },
        shape: { type: "circle" },
        size: { value: { min: 2, max: 4 } },
        opacity: { value: { min: 0.4, max: 0.85 } },
        move: reduce
          ? { enable: false }
          : {
              enable: true,
              speed: 1.1,
              direction: "none",
              random: true,
              straight: false,
              outModes: { default: "out" },
            },
        links: {
          enable: true,
          color: "#c0c0c0",
          opacity: 0.4,
          distance: 140,
          width: 1,
        },
      },
      interactivity: {
        detectsOn: "window",
        events: {
          onHover: { enable: !reduce, mode: "grab" },
          onClick: { enable: false },
          resize: { enable: true },
        },
        modes: {
          grab: { distance: 190, links: { opacity: 0.75, color: "#e5e7eb" } },
        },
      },
    }),
    [isMobile, reduce]
  );

  if (!ready) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="particles-background"
      className="pointer-events-none fixed inset-0"
      style={{ zIndex: -1 }}
    >
      <Particles id="gobax-particles" options={options} className="h-full w-full" />
    </div>
  );
};
